import { z } from 'zod';

/**
 * Variables de entorno del cliente. El `X-Client-Type` **no** es
 * configurable: es la constante `web` de `@alter/types` (`X_CLIENT_TYPE`).
 * El override de desarrollo que existía hasta la tanda 1 (2026-09-19)
 * permitía emitir `vr` para saltar el 2FA, y con eso cambiaba el claim
 * del JWT: el servidor declaraba audio WAV y, a futuro, dejaba fuera del
 * prompt la sección de `expresion_detalle` (nota de interfaz §2).
 */
const EnvSchema = z.object({
  /** URL del API REST. MVP: `https://api.mvp.alterrealitas.com`. */
  VITE_API_BASE_URL: z.string().url(),
  /**
   * URL del WebSocket (Socket.IO v4 sobre HTTPS). MVP:
   * `https://ws.mvp.alterrealitas.com`. Validado al boot aunque el WS lo
   * use la pantalla de sesión, así un .env mal configurado falla temprano.
   */
  VITE_WS_BASE_URL: z.string().url(),
});
export type Env = z.infer<typeof EnvSchema>;

/**
 * Parsea + valida el objeto de env vars. Pure function — testeable con
 * inputs sintéticos. Lanza `ZodError` con mensaje claro si algo falta.
 */
export function parseEnv(raw: Record<string, unknown>): Env {
  return EnvSchema.parse(raw);
}

// ----- Singleton del env, lazy -----

let _env: Env | null = null;

/** Set explícito desde `main.tsx` tras `parseEnv(import.meta.env)`. */
export function setEnv(env: Env): void {
  _env = env;
}

/** Acceso al env. Lanza si `setEnv` no se llamó (boot incompleto). */
export function getEnv(): Env {
  if (!_env) {
    throw new Error('Env not initialized — main.tsx must call setEnv() before any consumer');
  }
  return _env;
}
